'use strict';

/**
 * Initializes the marquee effect for the Why CKC section.
 *
 * @private
 * @function
 * @since 1.0.0
 */
function initWhyCKCMarquee() {
    $('.why-ckc-content, .be-a-part-of-it-content').each(function () {
        if ($(this).data('isCloned')) return;

        $(this).html(function (i, html) {
            return html + html; // duplicate all children
        });
        var duration = $(this).data('animation-speed') || 20; // default to 20 seconds if not specified

        $(this).addClass('scroll-speed').data('isCloned', true);
        $(this).css('animation', `scroll-left ${duration}s linear infinite`);
    });
}

initWhyCKCMarquee();
